import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { postData, putData } from "actions";
import { API_URL_templateSet } from "constants/api";
import { templateSetReducers } from "redux/templateSetSlice";

const InputModalTemplateSet = ({ isOpen, onClose, title, item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (item) {
      formik.setValues({
        name: item.name,
        active: item.active,
      });
    }
  }, [item, isOpen]);

  const formik = useFormik({
    initialValues: {
      name: "",
      active: 0,
    },
    onSubmit: (values) => {
      const formData = values;
      if (item) {
        // Jika item tersedia (dalam mode edit), lakukan pembaruan
        putData(
          `${API_URL_templateSet}${item.id}/`,
          formData,
          { dispatch, redux: templateSetReducers },
          "ADD_TEMPLATESET",
          () => {
            navigate("/administrator/email/templates");
          }
        );
      } else {
        // Jika tidak ada item (dalam mode tambah), lakukan penambahan baru
        postData(
          API_URL_templateSet,
          formData,
          { dispatch, redux: templateSetReducers },
          "ADD_TEMPLATESET",
          () => {
            navigate("/administrator/email/templates");
          }
        );
      }

      // Reset formik state
      formik.resetForm();

      // Tutup modal
      onClose();
    },
  });

  const handleclose = () => {
    formik.resetForm();
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-2/5 rounded-lg border-4 border-gray-500 overflow-hidden">
        <div className="flex justify-between bg-neutral-100 dark:bg-neutral-700 border-b-2 border-neutral-200 dark:border-neutral-600">
          <h2 className="text-2xl font-medium px-6 py-2 bg-neutral-100 dark:bg-neutral-700 border-b-2 border-neutral-200 dark:border-neutral-600">
            {title}
          </h2>
          <button
            type="button"
            className="mr-2 px-4 py-2 border  border-gray-300 text-black rounded-md"
            onClick={handleclose}
            title="Close Modal"
          >
            X
          </button>
        </div>
        <div className="w-full bg-neutral dark:bg-neutral-800">
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-7 px-6 py-4">
              <label htmlFor="name" className="block mb-1">
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="w-full p-2 border border-gray-300 rounded-md"
                value={formik.values.name}
                onChange={formik.handleChange}
              />
            </div>
            <div className="border-t border-gray-200">
              <div className="p-6 flex justify-between ">
                <button
                  type="button"
                  className="mr-2 px-4 py-2 border bg-red-600 hover:bg-red-500 border-gray-300 rounded-md text-white"
                  onClick={handleclose}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 border border-gray-300 bg-blue-800 hover:bg-blue-700 text-white rounded-md"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InputModalTemplateSet;
